import { render, staticRenderFns } from "./mainBusiness.vue?vue&type=template&id=3677acac&scoped=true"
import script from "./mainBusiness.vue?vue&type=script&lang=js"
export * from "./mainBusiness.vue?vue&type=script&lang=js"
import style0 from "./mainBusiness.vue?vue&type=style&index=0&id=3677acac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677acac",
  null
  
)

export default component.exports